const tagName = "video-section";

var css = /*css*/`
    ${tagName} {
        display: block;
        text-align: center;
        margin-top: 1rem;
        padding: 20px;
    }
    ${tagName} iframe {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        aspect-ratio: 16 / 9;
        border-radius: 20px;
        overflow: hidden;
        border: none;
        box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    }
`;

class VideoSection extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const videoURL = this.getAttribute("data-video-url");
        this.innerHTML = `
            <iframe src="${videoURL}" allow="autoplay; fullscreen" allowfullscreen></iframe>
            <style>${css}</style>
        `;
    }
}

customElements.define(tagName, VideoSection);

export default function render(videoURL) {
    return `<${tagName} data-video-url="${videoURL}"></${tagName}>`;
}
